import React, { useEffect, useState } from 'react'
import api from 'helpers/api'
import useProject from 'hooks/useProject'
import Spinner from 'components/spinner'
import { HUB_BASE } from 'routes'
import type { IScriptInventoryRow } from 'types'

const ScriptsPanel: React.FC = () => {
  const { project } = useProject()
  const [scripts, setScripts] = useState<IScriptInventoryRow[] | null>(null)

  useEffect(() => {
    // Reset to the loading state so rows from a previous hub never linger while the new hub loads.
    setScripts(null)
    // ProjectProvider uses '' before the hub loads — don't fetch (or render a misleading empty state) yet.
    if (!project.publicId) return
    let cancelled = false
    api
      .getHubScripts(project.publicId)
      .then((res) => {
        if (!cancelled) setScripts(res.data)
      })
      .catch(() => {
        if (!cancelled) setScripts([])
      })
    return () => {
      cancelled = true
    }
  }, [project.publicId])

  return (
    <div className="flex flex-col w-full py-5 px-[30px] gap-5">
      <div className="bg-really-light-yellow border border-alert text-orange px-4 py-3 rounded">
        Scripts are being deprecated in November 2026. The list below shows scripts currently in this hub.
      </div>

      {scripts === null && <Spinner />}

      {scripts !== null && scripts.length === 0 && <div>No scripts in this hub.</div>}

      {scripts !== null && scripts.length > 0 && (
        <table className="w-full text-left">
          <thead>
            <tr>
              <th className="py-2">Table</th>
              <th className="py-2">Column</th>
              <th className="py-2">Last updated</th>
            </tr>
          </thead>
          <tbody>
            {scripts.map((s) => (
              <tr key={s.columnPublicId} className="border-t">
                <td className="py-2">
                  {s.viewPublicId ? (
                    <a
                      href={`${HUB_BASE}${project.publicId}/table/${s.tablePublicId}/view/${s.viewPublicId}`}
                      className="text-blue underline"
                    >
                      {s.tableName}
                    </a>
                  ) : (
                    s.tableName
                  )}
                </td>
                <td className="py-2">{s.columnName}</td>
                <td className="py-2">{new Date(s.scriptUpdatedAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default ScriptsPanel
